// React
import { useContext } from "react";

// Relative imports
import { ContextMenuActionsContext } from "./context";

let warned = false;
const noop = () => false;
const FALLBACK = {
  openAt: noop,
  openFrom: noop,
  close: () => {},
  bind: () => ({}),
};

/**
 * The app's context menu (one instance, mounted by ContextMenuProvider in App.jsx).
 * @returns {{
 *   openAt: (where: {x:number,y:number} | Event, items: Array|Function, options?: object) => boolean,
 *   openFrom: (anchorEl: Element, items: Array|Function, options?: object) => boolean,
 *   close: () => void,
 *   bind: (getItems: (event) => Array, options?: { longPress?: boolean, disabled?: boolean, options?: object }) => object,
 * }} stable functions (safe in deps arrays)
 */
export default function useContextMenu() {
  const actions = useContext(ContextMenuActionsContext);
  if (actions) return actions;
  if (!warned && import.meta.env?.DEV) {
    warned = true;
    console.warn("useContextMenu: no ContextMenuProvider above this component, the menu is off");
  }
  return FALLBACK;
}
